import { z } from "zod";
z.config({ jitless: true });
export const customerOperationsSchemaVersionSchema = z.literal("2026-09-25.1");
const ulidSchema = z.string().regex(/^[0-9A-HJKMNP-TV-Z]{26}$/u);
const uuidSchema = z.string().uuid();
/**
 * Customer-operations identifiers are supplied by server-resolved construction contexts. They are
 * deliberately limited to the two opaque identifier formats already used by the platform.
 */
export const customerOperationsOpaqueIdSchema = z.union([ulidSchema, uuidSchema]);
export const customerOperationsEventIdSchema = customerOperationsOpaqueIdSchema;
export const customerOperationsCorrelationIdSchema = uuidSchema;
export const customerOperationsCausationIdSchema = customerOperationsOpaqueIdSchema;
export const customerOperationsAuthoritySchema = z.enum([
    "SERVER",
    "CLIENT_OBSERVED",
    "PROVIDER",
    "AWS_SERVICE",
]);
export const customerOperationsEventFamilySchema = z.enum([
    "IDENTITY_AUTH",
    "COMMERCE_GIFT",
    "BOOK_COLLABORATION",
    "CAPTURE_MEDIA",
    "PRODUCTION",
    "REVIEW_OUTPUT",
    "LC97_EVIDENCE",
    "PRINT_FULFILLMENT",
    "SUPPORT",
    "RELIABILITY",
    "CLIENT_OBSERVED",
]);
export const customerOperationsOutcomeSchema = z.enum([
    "SUCCEEDED",
    "ACCEPTED",
    "REJECTED",
    "FAILED",
    "RECOVERED",
    "OBSERVED",
    "SCHEDULED",
]);
export const customerOperationsReasonCodeSchema = z.enum([
    "CUSTOMER_REQUESTED",
    "OPERATOR_ACTION",
    "POLICY_DECISION",
    "VALIDATION_REJECTED",
    "MEMBERSHIP_REQUIRED",
    "AUTHENTICATION_REJECTED",
    "PROVIDER_CONFIRMED",
    "PROVIDER_REJECTED",
    "CONFLICT_DETECTED",
    "NETWORK_FAILURE_OBSERVED",
    "SYSTEM_FAILURE",
    "RETRY_SCHEDULED",
    "DEAD_LETTER_REDRIVE",
    "RECONCILIATION_MATCHED",
    "RECONCILIATION_DIVERGED",
    "RATE_LIMITED",
    "RETENTION_EXPIRED",
    "CUSTOMER_DELETION",
    "LEGAL_HOLD",
]);
export const customerOperationsProducerSchema = z.enum([
    "CUSTOMER_API",
    "SUPPORT_API",
    "ADMIN_API",
    "WORKFLOW",
    "COGNITO_TRIGGER",
    "PROVIDER_WEBHOOK",
    "PROVIDER_RECONCILER",
    "AWS_EVENT_NORMALIZER",
    "OPERATIONS_RECOVERY",
]);
export const customerOperationsStageSchema = z.enum([
    "development",
    "staging",
    "public-sandbox",
    "production",
]);
export const customerOperationsAggregateTypeSchema = z.enum([
    "PROFILE",
    "CHECKOUT",
    "VOUCHER",
    "REWARD",
    "BOOK",
    "SOURCE",
    "GENERATION",
    "REVISION",
    "EXPORT",
    "PRODUCTION_EVIDENCE",
    "PRINT_AUTHORIZATION",
    "ORDER",
    "FULFILLMENT",
    "SUPPORT_TICKET",
    "OUTBOX",
    "PROJECTION",
    "RECONCILIATION",
]);
export const customerOperationsAggregateSchema = z
    .object({
    type: customerOperationsAggregateTypeSchema,
    id: customerOperationsOpaqueIdSchema,
    version: z.number().int().positive(),
})
    .strict();
export const customerOperationsSubjectSchema = z
    .object({
    customerId: customerOperationsOpaqueIdSchema.optional(),
    bookId: customerOperationsOpaqueIdSchema.optional(),
    workflowId: customerOperationsOpaqueIdSchema.optional(),
    artifactId: customerOperationsOpaqueIdSchema.optional(),
    orderId: customerOperationsOpaqueIdSchema.optional(),
    ticketId: customerOperationsOpaqueIdSchema.optional(),
})
    .strict()
    .refine((subject) => Object.values(subject).some((value) => value !== undefined), {
    message: "An operations subject must contain at least one opaque identifier.",
});
export const customerOperationsEventIdentityPolicy = Object.freeze({
    stableApplicationEventIdField: "eventId",
    acceptsEventBridgeEventId: false,
    eventBridgeReplayMayChangeDeliveryId: true,
});
//# sourceMappingURL=customer-operations-core.js.map